import { render, staticRenderFns } from "./VehicleLanguage.vue?vue&type=template&id=378525e6&scoped=true"
import script from "./VehicleLanguage.vue?vue&type=script&lang=ts"
export * from "./VehicleLanguage.vue?vue&type=script&lang=ts"
import style0 from "./VehicleLanguage.vue?vue&type=style&index=0&id=378525e6&prod&scoped=true&lang=css"
import style1 from "./VehicleLanguage.vue?vue&type=style&index=1&id=378525e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378525e6",
  null
  
)

export default component.exports